<template>
    <v-dialog
        :model-value="showModal"
        @update:model-value="closeKeyModal"
        :fullscreen="$vuetify.display.mobile"
        :max-width="$vuetify.display.mobile ? '100%' : '600'"
        persistent
    >
        <v-card>
            <v-card-title class="headline">
                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <h2>Your Key</h2>
                    <v-btn icon @click="closeKeyModal">
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>
                </div>
            </v-card-title>
            <v-card-text>
                <p>Your key can be found below:</p>
                <p v-if="keyValue">
                    <code>{{ keyValue.value }}</code>
                    <span id="copy-key" v-if="showCopyIcon" @click="copyToClipboard">
                        <v-icon :icon="'fas fa-copy'" id="copy-icon"></v-icon>
                    </span>
                    <span v-if="showCheckIcon" id="check-key">
                        <v-icon :icon="'fas fa-check'"></v-icon>
                    </span>
                </p>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

export default {
    name: 'KeyModal',
    props: {
        showModal: Boolean,
    },
    setup(props, context) {
        const store = useStore();

        const keyValue = computed(() => store.state.keyValue);
        const showCheckIcon = ref(false);
        const showCopyIcon = ref(true);

        const closeKeyModal = () => {
            context.emit('update:showModal', false);
            store.commit('SET_KEY_VALUE', null);
        }

        const copyToClipboard = async () => {
            const textToCopy = keyValue.value.value;
            try {
                const textArea = document.createElement('textarea');
                textArea.value = textToCopy;
                document.body.appendChild(textArea);
                textArea.select();
                await navigator.clipboard.writeText(textToCopy);
                document.body.removeChild(textArea);
                showCheckIcon.value = true;
                showCopyIcon.value = false;
                setTimeout(() => {
                    showCheckIcon.value = false;
                    showCopyIcon.value = true;
                }, 3000);
            } catch (error) {
                console.error('Failed to copy text to clipboard:', error);
            }
        };


        return {
            keyValue,
            showCheckIcon,
            showCopyIcon,
            closeKeyModal,
            copyToClipboard,
        };
    },
};
</script>
